<template>
    <div class="pricelist-banner">
        <div class="pricelist-banner__header">
            <img src="/wp-content/themes/rigips/images/v3/banners/pricelist.png">
            <div class="textcontent">
                <h3 class="pricelist-banner__title">Ceník online</h3>
                <h4 class="pricelist-banner__subtitle">Objevte jednoduchý způsob, jak získat okamžitý přístup k základním cenám našich materiálů. S novým online ceníkem Rigips zjistíte aktuální informace bez zdržení.</h4>
            </div>
        </div>

        <a class="button view-primary-light" href="https://cenik.rigips.cz/">Otevřít</a>
    </div>
</template>

<script>
    export default {
        name: "PricelistBanner"
    }
</script>



// WEBPACK FOOTER //
// src/components/cad/PricelistBanner.vue